import { CommApiInstance } from "Utils/CommApiInstance";


const EmlAthnNoSendApi = async (
    emlAddr:string      ,
    athnPrpsCd:string   ,
    ReCaptchaToken:string,
) => {
    return await CommApiInstance.post(`athn/idnt_mthd/eml/athn_no_send`,{
        apiBody: {
            emlAddr:emlAddr,
            athnPrpsCd:athnPrpsCd,
            cptchTkn:ReCaptchaToken
        }
    })
    .then((Resp) => Resp.data);
}

export default EmlAthnNoSendApi;